import React, { useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import {
  Upload,
  Download,
  Plus,
  CalendarDays,
  CalendarCheck,
  CalendarX,
  Clock,
  Train,
  ArrowUp,
  ArrowDown,
  Edit3,
  Users,
  MapPin,
  Pencil,
} from "lucide-react";
const metroLines = ["Blue", "Green", "Red"];

export default function Timetables() {
  const [selectedLine, setSelectedLine] = useState("Blue");
  const [activeTab, setActiveTab] = useState("Weekday");
  const tabs = [
    { name: "Weekday", icon: <CalendarDays size={18} /> },
    { name: "Saturday", icon: <CalendarCheck size={18} /> },
    { name: "Sunday", icon: <CalendarX size={18} /> },
  ];
  const scheduleData = [
    { time: "06:00", frequency: "8 min", direction: "Down", status: "Active" },
    { time: "06:30", frequency: "6 min", direction: "Up", status: "Peak" },
    { time: "07:00", frequency: "4 min", direction: "Down", status: "Peak" },
    { time: "08:00", frequency: "6 min", direction: "Up", status: "Active" },
  ];
  const getTabClasses = (tab) => {
    return `flex items-center gap-1 justify-center px-3 py-[10px] text-[14px] rounded-lg font-semibold hover:bg-[var(--primary-color)] transition-all duration-200  ${
      activeTab === tab
        ? "bg-[var(--primary-color)] text-white shadow-md"
        : "bg-white text-[var(--grey-text)] hover:bg-gray-100"
    }`;
  };const getSelectedLineColor = () => {
    const line = metroLines.find((l) => l.value === selectedLine);
    return line?.color || "bg-blue-500";
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      Peak: "bg-red-100 text-red-700 border border-red-200",
      Active: "bg-green-100 text-green-700 border border-green-200",
    };
    return statusConfig[status] || statusConfig.Active;
  };
  return (
    <MasterLayout>
      <div className="w-full">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 w-full flex flex-col justify-between">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 h-full">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 mb-0">
                Metro Timetable Management
              </h1>
              <p className="text-sm text-gray-600 mt-1 mb-0">
                Manage schedules, frequency and operational hours
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button className="flex items-center justify-center gap-2 px-4 py-2 btn-secoundary rounded-md transition duration-200">
                <Upload className="h-5 w-5" />
                Import
              </button>
              <button className="flex items-center justify-center gap-2 px-4 py-2 btn-secoundary rounded-md transition duration-200">
                <Download className="h-5 w-5" />
                Export
              </button>
              <button className="flex items-center justify-center gap-2 px-4 py-2  btn-primary rounded-md transition duration-200">
                <Plus className="h-5 w-5" />
                Add Schedule
              </button>
            </div>
          </div>
        </div>

        {/* Metro Line Selector */}
        <div className="mt-3 rounded-lg border bg-card p-4 shadow-sm w-full flex flex-col justify-between">
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center h-full">
            <label className="text-sm font-medium">Select Metro Line:</label>
            <select
              className="h-10 border px-[35px] py-2 rounded-md bg-background text-sm max-w-fit  form-select"
              value={selectedLine}
              onChange={(e) => setSelectedLine(e.target.value)}
            >
              {metroLines.map((line) => (
                <option key={line} value={line}>
                  {line} Line
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="mt-4 w-full space-y-4">
     

        {/* Tab Content */}
        <div className="bg-white rounded-lg border shadow-sm min-h-[300px]">
          <div className="flex border-b border-gray-200">
                  {tabs.map((tab) => (
                    <button
                      key={tab.name}
                      onClick={() => setActiveTab(tab.name)}
                      className={`flex-1 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                        activeTab === tab.name
                          ? "border-blue-500 text-[var(--primary-color)] bg-blue-50"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      {tab.name}
                    </button>
                  ))}
                </div>
          {activeTab === "Weekday" && (
            <div className="p-6">
              {/* Header */}
              <div className="flex  gap-2 mb-6">
                <Clock className="h-6 w-6 text-[var(--primary-color)] mt-[5px]" />
                <div>
                  <h3 className="text-xl font-semibold text-[var(--black)] mb-1">
                    Weekday Schedule - {selectedLine} Line
                  </h3>
                  <p className="text-sm text-[var(--grey-text)]">
                    Operational hours and frequency details
                  </p>
                </div>
              </div>

              {/* Stats Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                <div className="bg-blue-50 flex flex-col items-center border border-blue-200 p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <Clock className="h-5 w-5 text-[var(--primary-color)]" />
                  </div>
                  <div className="text-2xl font-bold text-[var(--primary-color)]">
                    05:30
                  </div>
                  <div className="text-sm text-[var(--primary-color)]">
                    First Train
                  </div>
                </div>

                <div className="bg-purple-50 flex flex-col items-center border border-purple-200 p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <Clock className="h-5 w-5 text-purple-600" />
                  </div>
                  <div className="text-2xl font-bold text-purple-700">
                    23:30
                  </div>
                  <div className="text-sm text-purple-600">Last Train</div>
                </div>

                <div className="bg-green-50  flex flex-col items-center border border-green-200 p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <Train className="h-5 w-5 text-green-600" />
                  </div>
                  <div className="text-2xl font-bold text-green-700">4 min</div>
                  <div className="text-sm text-green-600">Peak Frequency</div>
                </div>

                <div className="bg-orange-50 flex flex-col items-center border border-orange-200 p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <Users className="h-5 w-5 text-orange-600" />
                  </div>
                  <div className="text-2xl font-bold text-orange-700">
                    8 min
                  </div>
                  <div className="text-sm text-orange-600">
                    Off-Peak Frequency
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b border-[#e4e7ea]">
                      <tr>
                        <th className="text-left p-4 font-medium text-[var(--black)] text-sm">
                          <div className="flex items-center gap-2">
                            <Clock className="h-4 w-4" />
                            Time
                          </div>
                        </th>
                        <th className="text-left p-4 font-medium text-[var(--black)] text-sm">
                          Frequency
                        </th>
                        <th className="text-left p-4 font-medium text-[var(--black)] text-sm">
                          <div className="flex items-center gap-2">
                            <Train className="h-4 w-4" />
                            Direction
                          </div>
                        </th>
                        <th className="text-left p-4 font-medium text-[var(--black)] text-sm">
                          Status
                        </th>

                        <th
                          className="text-right p-4 font-medium text-[var(--black)] text-sm"
                          style={{ paddingRight: "2rem" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {scheduleData.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="p-4">
                            <div className="flex items-center gap-2">
                              <div
                                className={`w-2 h-2 rounded-full ${getSelectedLineColor()}`}
                              ></div>
                              <span className="font-semibold text-gray-900">
                                {item.time}
                              </span>
                            </div>
                          </td>
                          <td className="p-4">
                            <span className="px-2 py-1 bg-blue-100 text-[var(--primary-color)] rounded text-sm font-medium">
                              {item.frequency}
                            </span>
                          </td>
                          <td className="p-4">
                            <div className="flex items-center gap-2">
                              {item.direction === "Up" ? (
                                <ArrowUp className="h-4 w-4 text-green-500" />
                              ) : (
                                <ArrowDown className="h-4 w-4 text-[var(--primary-color)]" />
                              )}
                              <span className="text-[var(--grey-text)]">
                                {item.direction}
                              </span>
                            </div>
                          </td>
                          <td className="p-4">
                            <span
                              className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(
                                item.status
                              )}`}
                            >
                              {item.status}
                            </span>
                          </td>

                          <td className="p-4 text-right ">
                            <div className="flex items-center justify-end gap-2 ">
                              <button
                                className="p-2 text-[var(--grey-text)] hover:bg-gray-100 rounded-lg transition duration-200"
                                title="Edit"
                              >
                                <Pencil className="h-4 w-4" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {activeTab === "Saturday" && (
            <div className="p-8 text-center">
              <div className="max-w-sm mx-auto">
                <CalendarCheck className="h-12 w-12 text-[var(--grey-text)] mx-auto mb-4" />
                <h2 className="text-xl font-semibold text-[var(--black)] mb-2">
                  Saturday Timetable
                </h2>
                <p className="text-[var(--grey-text)] mb-4">
                  Configure weekend schedule for Saturday operations.
                </p>
                <button className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 mx-auto">
                  <Plus className="h-4 w-4" />
                  Add Saturday Schedule
                </button>
              </div>
            </div>
          )}

          {activeTab === "Sunday" && (
            <div className="p-8 text-center">
              <div className="max-w-sm mx-auto">
                <CalendarX className="h-12 w-12 text-[var(--grey-text)] mx-auto mb-4" />
                <h2 className="text-xl font-semibold text-[var(--black)] mb-2">
                  Sunday Timetable
                </h2>
                <p className="text-[var(--grey-text)] mb-4">
                  Configure weekend schedule for Sunday operations.
                </p>
                <button className="flex items-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-lg hover:bg-[var(--primary-hover)] transition-colors duration-200 mx-auto">
                  <Plus className="h-4 w-4" />
                  Add Sunday Schedule
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </MasterLayout>
  );
}
